
  export default {
    data() {
      return {
        selected: null
      }
    },
    props: {
      blok: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      mobile() {
        return (this.$mq == 'sm' || this.$mq == 'md')
      }
    }
  }
